import { render } from "./ButtonLoader.vue?vue&type=template&id=55dbb76c&scoped=true"
import script from "./ButtonLoader.vue?vue&type=script&lang=js"
export * from "./ButtonLoader.vue?vue&type=script&lang=js"

import "./ButtonLoader.vue?vue&type=style&index=0&id=55dbb76c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dbb76c"]])

export default __exports__